/**
 * Canonical list of TenantModule values a superadmin can grant to a tenant.
 *
 * SoT: reservationsystem/src/main/java/com/coworking/reservationsystem/model/entity/TenantModule.java
 * — keep in sync. No BE endpoint exposes this catalog today: TenantModule.names() is only used inline
 * in a validation error message (Tenant.java), and /api/v1/me/modules returns the CURRENT user's already
 * -visible modules (useless for a brand-new tenant with nothing enabled yet), not the full enum catalog.
 * So this list is hand-maintained. Order mirrors the enum declaration order.
 *
 * EVENTS is one backing module for two product identities (Night Club + Events/Evenimente) — see the
 * enum's own comment (NCEV-M0-F2) and frontend/src/admin/verticalRegistry.ts (NIGHT_CLUB + EVENT_VENUE
 * both declare `module: 'EVENTS'`). The label below names both so a platform operator granting the
 * single "EVENTS" tenant module understands it also unlocks Night Club.
 */
export interface ModuleOption {
  value: string;
  label: string;
}

export const MODULE_OPTIONS: ModuleOption[] = [
  { value: 'RESTAURANT', label: 'Restaurant' },
  { value: 'HOTEL', label: 'Hotel' },
  { value: 'SPA', label: 'Spa' },
  { value: 'FITNESS', label: 'Fitness' },
  { value: 'FAST_FOOD', label: 'Fast Food' },
  { value: 'EVENTS', label: 'Night Club & Events' },
  { value: 'MEDTRACE', label: 'MedTrace' },
];
